import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import AuthShell from "./AuthShell";
import { api } from "@/lib/api";
import { AUTH } from "@/constants/testIds";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Something went wrong");
    } finally { setSubmitting(false); }
  };

  return (
    <AuthShell title="Reset your password" subtitle="We'll email you a secure reset link">
      {done ? (
        <div className="sqit-card p-6 text-center">
          <p className="text-gray-700">If an account exists for that email, a reset link has been sent.</p>
          <Link to="/login" className="mt-4 inline-block text-[#538135] font-semibold">Back to sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-xs font-semibold text-gray-700 mb-1.5">Email address</label>
            <input
              data-testid={AUTH.forgotEmail}
              type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#EAF4E3] focus:border-[#538135]"
            />
          </div>
          <button
            data-testid={AUTH.forgotSubmit}
            disabled={submitting}
            className="w-full bg-[#538135] text-white hover:bg-[#09582D] rounded-md px-4 py-3 text-sm font-semibold disabled:opacity-60"
          >
            {submitting ? "Sending…" : "Send reset link"}
          </button>
          <Link to="/login" className="block text-center text-sm text-gray-600 hover:text-gray-900">
            Back to sign in
          </Link>
        </form>
      )}
    </AuthShell>
  );
}
